import { type TFindAllStructurePartnersResponse, useDebounce, useFindAllStructurePartners } from "@api";
import { useEffect, useState } from "react";

export const useAutocompleteStructurePartners = () => {
  const [{ data, loading }, findAllStructurePartner] = useFindAllStructurePartners();
  const [options, setOptions] = useState<TFindAllStructurePartnersResponse>([]);
  const [inputValue, setInputValue] = useState<string>("");

  const onChange = useDebounce(
    async (_, value: string) => {
      if (value.length < 2) {
        setOptions([]);
        return;
      }
      await findAllStructurePartner({ search: value });
    },
    750,
    []
  );

  useEffect(() => {
    if (data) {
      setOptions(data);
    }
  }, [data]);

  return { options, onChange, loading, inputValue, setInputValue };
};
